import { Outlet } from 'react-router-dom';
import SkipLink from '../common/SkipLink';
import Nav from './Nav';
import Footer from './Footer';

/**
 * The public site shell.
 *
 * Every page renders inside this: skip link, header, main, footer. Keeping the
 * shell separate from the pages means the header and footer mount once and
 * survive navigation, and no page has to remember to render them.
 *
 * `tabIndex="-1"` on <main> is what makes the skip link work: it moves the
 * focus, not just the viewport, so the next Tab starts inside the content.
 */
const SiteLayout = () => (
  <div className="site-layout">
    <SkipLink />
    <Nav />
    <main className="site-main" id="main-content" tabIndex={-1}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default SiteLayout;
